import { ScoreableSearchResult, SearchResult } from '../interfaces/interfaces';
import { store } from '../redux/store';
import { adressApi, parseAddressSearchResponse } from '../redux/slice/fetchAdressApi';
import Fuse from 'fuse.js';


//export const convert2ScoreableSearchResult = (searchResult:SearchResult[]) : ScoreableSearchResult[] => {}


const createEmptyAdressSearchIndex = (): Fuse<SearchResult> =>
    new Fuse([], {
        includeScore: true,
        threshold: 0.9,
        isCaseSensitive: false,
        keys: ['label']
    })


/**
*
* @param query Searchs paralell all visible mst layers, that have an index.
* @param state The state, that holds all layers and indices.
* @returns The mst search result.
*/
export const adressSearch = (query: string, limit: number, boostFact = 1) =>
    new Promise<ScoreableSearchResult[]>((resolve, reject) => {
        store.dispatch(adressApi.endpoints.searchAdress.initiate(query)).then(
            response => {
                if (response.data) {
                    const adressSearchIndex = createEmptyAdressSearchIndex();
                    parseAddressSearchResponse(response.data).forEach(searchResult => adressSearchIndex.add(searchResult))
                    resolve(adressSearchIndex.search(query).map(searchResult => {
                        return {
                            score: searchResult.score ? (1 - searchResult.score) * boostFact : 0,
                            id: searchResult.item.id,
                            label: searchResult.item.label,
                            layer: searchResult.item.layer,
                            centroid: searchResult.item.centroid,
                            extent: searchResult.item.extent
                        }
                    }));
                } else {
                    reject();
                }
            }
        );

    });
